import { memo, RefObject, useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

import Icon from '@/components/Icon/Icon'
import { useAppSelector } from '@/store/hooks'
import { CardListType, PageCardType } from '@/types/card'

import Grid from './Grid'

type Props = {
  cardLists: CardListType[]
  enableCount?: boolean
  groupCardLists?: boolean
  handleResize: () => void
  hideSidebar?: boolean
  loading: boolean
  numCols: number
  pageCommander?: PageCardType
  rightRef: RefObject<HTMLDivElement>
  scrollToCardLists: () => void
  sectionRefs: RefObject<HTMLDivElement>[]
  showSearch?: boolean
}

const CardView = ({
  cardLists,
  enableCount,
  groupCardLists,
  handleResize,
  hideSidebar,
  loading,
  numCols,
  pageCommander,
  rightRef,
  // scrollToCardLists,
  sectionRefs,
  showSearch,
}: Props) => {
  const groupedBy = useAppSelector((state) => state.cardlists.groupedBy)
  const [search, setSearch] = useState<string>('')

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    handleResize()
  }, [rightRef.current?.offsetWidth])

  useEffect(() => {
    /* if (firstRender) setFirstRender(false)
    else scrollToCardLists() */
    setSearch('')
  }, [cardLists])

  const searchedCardLists =
    search.length > 0
      ? cardLists.map((cardList) => ({
          ...cardList,
          cardviews: cardList.cardviews.filter(
            ({ label, name }) =>
              label.toLowerCase().includes(search.toLowerCase()) || name.toLowerCase().includes(search.toLowerCase()),
          ),
        }))
      : cardLists

  return (
    <div className='flex-grow-1' ref={rightRef}>
      {showSearch && (
        <div className='m-4'>
          <InputGroup className='mb-3'>
            <InputGroup.Text id='basic-addon1'>
              <Icon icon='search' />
            </InputGroup.Text>
            <Form.Control onChange={(e) => setSearch(e.target.value)} placeholder='Search' />
          </InputGroup>
        </div>
      )}
      <Grid
        cardLists={searchedCardLists}
        enableCount={enableCount}
        groupCardLists={groupCardLists && groupedBy === 'default'}
        hideSidebar={hideSidebar}
        loading={loading}
        numCols={numCols}
        pageCommander={pageCommander}
        sectionRefs={sectionRefs}
      />
    </div>
  )
}

export default memo(CardView)
